import { constants } from '@bedc/constants';

import { Request as BaseRequest } from '../../../generic/search/Request';

export const Request = BaseRequest({
	sortFields: constants.wholeHouse.material.sortFields,
	columnFields: constants.wholeHouse.material.columnFields,
	standardFilterFields: constants.wholeHouse.material.osStandardFilterFields,
	dateFilterFields: constants.wholeHouse.material.osDateFilterFields,
	stageStatusFilterFields: [] as const,
	booleanFilterFields: [] as const,
});
